import { types } from "../actions";

const initialState = {
   widgetConfig: [],
   selectedTimerValue: ""
};

const widgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_WIDGET_CONFIG:
        return {
            ...state,
            widgetConfig: action.payload
        }
    case types.SELECTED_TIMER_DATA:
        return {
            ...state,
            selectedTimerValue: action.timerValue        
          }
    default:
        return state;
  }
};
export default widgetReducer;